import { render } from "./TemplateDbsMyBooking.vue?vue&type=template&id=e50ea852&scoped=true"
import script from "./TemplateDbsMyBooking.vue?vue&type=script&lang=js"
export * from "./TemplateDbsMyBooking.vue?vue&type=script&lang=js"

import "./TemplateDbsMyBooking.vue?vue&type=style&index=0&id=e50ea852&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e50ea852"

export default script